import Guid from "common/values/guid/guid";
import moment from "moment";
import NetworkedGroup from "users/entities/networked-group/networked-group";

export default class NetworkedGroupApiResponse {
  id?: string;
  name?: string;
  description?: string;
  memberUserIds: string[] = [];
  created?: string;

  constructor(values: Readonly<Partial<NetworkedGroupApiResponse>>) {
    if (!values.id) throw new Error("NetworkedGroupApiResponse must have an id");
    if (!values.created) throw new Error("NetworkedGroupApiResponse must have a created date");

    Object.assign(this, values);
  }

  deserialize(): NetworkedGroup {
    return new NetworkedGroup(
      new Guid(this.id!),
      this.name,
      this.description,
      this.memberUserIds.map(id => new Guid(id)),
      moment(this.created)
    );
  }
}
